import React, { useCallback, useEffect, useState } from 'react';

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import { Tab, Tabs } from '@mui/material';
import LoadingBox from '../LoadingBox';

interface Props {
  options?: string[];
  selected: string;
  onSelect: (selected: string) => void;
}

export default function TabMenu({
  options = [],
  selected,
  onSelect
}: Props) {
  const [ping, setPing] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [tab, setTab] = useState("");

  // const load = useCallback(() => {
  //   setTab(selected);
  // }, [selected]);
  
  // useEffect(() => {
  //   if (!fetched) {
  //     setFetched(true);
  //     setLoading(true);
  //     setTimeout(() => {
  //       load();
  //     }, 100);
  //   }
  // }, [fetched]);

  // if (!fetched || loading) {
  //   return (<LoadingBox />);
  // } else {
  return (
    <Tabs value={selected} onChange={(_, val) => {
      onSelect(val);
      setPing(!ping);
    }} style={{ marginBottom: 16 }}>
      { options.map(option => {
        return (
          <Tab label={option} value={option} key={option} />
        );
      })}
    </Tabs>
  );
  // }
}
